import React, { useEffect, useState, useContext } from 'react';
import { Container } from 'reactstrap';
import Selected from '../ManageOrders/Selected';
import BookmarkListing from './BookmarkListing';
import Section from './Section';
import { getStockById } from '../../../api/stock/getStockById.js';
import {
  getAllBookmark,
  BookmarkDelete,
} from '../../../api/BookMarks/BookmarkApi.js';
import Pagination from './Pagination';
import { AuthContext } from '../../ExtraPages/AuthProvider';

const BookMarkJobs = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true); // Add loading state
  const itemsPerPage = 6;

  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  const fetchBookMarkData = async () => {
    setLoading(true); // Set loading to true when fetching starts
    console.log('userId', userId);
    try {
      const response = await getAllBookmark(userId);
      console.log('Bookmark Response:', response);

      if (response && Array.isArray(response.data)) {
        const data = response.data;

        // Fetch additional data for each itemId
        const detailedData = await Promise.all(
          data.map(async (item) => {
            try {
              const detailedResponse = await getStockById(item.itemId);
              console.log('detailedResponse:', detailedResponse);
              return { ...item, details: detailedResponse.data };
            } catch (error) {
              console.error(
                `Error fetching details for itemId ${item.itemId}:`,
                error
              );
              return { ...item, details: null };
            }
          })
        );

        setFilteredData(detailedData);
      } else {
        console.warn('No stock data found or data is not an array');
        setFilteredData([]);
      }
    } catch (error) {
      console.error('Error fetching stock data:', error);
      setFilteredData([]);
    } finally {
      setLoading(false); // Set loading to false when fetching completes
    }
  };

  useEffect(() => {
    if (userId) {
      fetchBookMarkData(); // Fetch data only when userId is available
    }
  }, [userId]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const deleteItems = async (deleteItem) => {
    try {
      const deleteResponse = await BookmarkDelete(deleteItem);
      console.log('Delete Response:', deleteResponse);
      await fetchBookMarkData();
    } catch (error) {
      alert('An error occurred while deleting the item or fetching data');
      console.error('Error:', error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  document.title =
    'Bookmarks Jobs | Jobcy - Job Listing Template | Themesdesign';

  return (
    <React.Fragment>
      <section
        className="section gaps bg-light"
        style={{ paddingTop: '80px' }}
      >
        <Container fluid>
          <Section link="Bookmarks" />
          {loading ? (
            <div
              className="loading-container"
              style={{ textAlign: 'center', padding: '50px' }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading bookmarks...</p>
            </div>
          ) : paginatedData && paginatedData.length > 0 ? (
            <div>
              <BookmarkListing
                BookMarkdata={paginatedData}
                onDelete={deleteItems}
              />
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          ) : (
            <div className="no-result-container">
              <i
                className="mdi mdi-bookmark"
                style={{ fontSize: '56px' }}
              ></i>
              <p>No bookmarks available to display.</p>
              <a
                href="/stocks"
                className="btn btn-primary"
              >
                Back to Stock
              </a>
            </div>
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default BookMarkJobs;